"use client";

import { useCallback, useRef } from "react";
import type { ProposalEventType } from "@/db/schema/proposal-events";

// Signal chaud de relance : envoie le TYPE d'interaction (jamais ce que le
// prospect a saisi) à /api/track/event, une seule fois par type et par
// affichage de la page. Désactivé pour une session super-admin (`enabled`).
export function useTrackEvent(slug: string, enabled: boolean) {
  const sent = useRef<Set<ProposalEventType>>(new Set());
  return useCallback(
    (type: ProposalEventType) => {
      if (!enabled || sent.current.has(type)) return;
      sent.current.add(type);
      const body = JSON.stringify({ slug, type });
      try {
        if (!navigator.sendBeacon?.("/api/track/event", new Blob([body], { type: "application/json" }))) {
          void fetch("/api/track/event", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
        }
      } catch {
        /* le tracking ne doit jamais casser la démo */
      }
    },
    [slug, enabled]
  );
}
